import {
  fetchAllControls,
  fetchAllResponses,
  fetchAllControlsAndResponses,
  create,
  cancel
} from 'api/control';
import { REQUEST_SUCCESS, REQUEST_FAIL } from 'reducers/modal/actions';
import { mapControlResponses } from './utils';

export const GET_ALL_CONTROLS_SUCCESS = 'GET_ALL_CONTROLS_SUCCESS';
export const CREATE_CONTROL_SUCCESS = 'CREATE_CONTROL_SUCCESS';
export const CANCEL_CONTROL_SUCCESS = 'CANCEL_CONTROL_SUCCESS';
export const UPDATE_CONTROLS = 'UPDATE_CONTROLS';
export const GET_DELETED_CONTROLS_SUCCESS = 'GET_DELETED_CONTROLS_SUCCESS';
export const UPDATE_DELETED_CONTROLS = 'UPDATE_DELETED_CONTROLS';
export const SET_CONTROLS_SUCCESS = 'SET_CONTROLS_SUCCESS';
export const SET_DELETED_CONTROLS_SUCCESS = 'SET_DELETED_CONTROLS_SUCCESS';

export const getAllControls = () => async dispatch => {
  try {
    const controls = await fetchAllControls();
    const responses = await fetchAllResponses();
    const updatedControls = mapControlResponses(controls, responses);
    return dispatch({
      type: GET_ALL_CONTROLS_SUCCESS,
      data: updatedControls
    });
  } catch (err) {
    // Redundant catch-throw, but maintaining this until we update polling
    throw err;
  }
};

export const getDeletedControls = () => async dispatch => {
  try {
    const deletedControls = await fetchAllControls({ deleted: true });
    const responses = await fetchAllResponses();
    const updatedDeletedControls = mapControlResponses(
      deletedControls,
      responses
    );
    return dispatch({
      type: GET_DELETED_CONTROLS_SUCCESS,
      data: updatedDeletedControls
    });
  } catch (err) {
    // Redundant catch-throw, but maintaining this until we update polling
    throw err;
  }
};

export const createControl = control => async (dispatch, getState) => {
  try {
    const { controlId } = await create(control);
    const queryParams = {};
    const isActiveControl =
      control.start + control.duration > new Date().getTime();
    if (isActiveControl) {
      queryParams.deleted = true;
    }
    const newControls = await fetchAllControlsAndResponses(queryParams);
    dispatch({
      type: REQUEST_SUCCESS,
      message: `Control ${control.description} create success`
    });
    dispatch({
      type: CREATE_CONTROL_SUCCESS,
      data: newControls
    });
    return { controlId };
  } catch (err) {
    dispatch({
      type: REQUEST_FAIL,
      message: `Control ${control.description} create failed`
    });
    throw err;
  }
};

export const cancelControl = (controlId, cancelValues) => async dispatch => {
  try {
    await cancel(controlId, cancelValues);
    await getAllControls();

    dispatch({
      type: REQUEST_SUCCESS,
      message: `Control ${controlId} cancel success`
    });
    return dispatch({
      type: CANCEL_CONTROL_SUCCESS,
      data: controlId
    });
  } catch (err) {
    dispatch({
      type: REQUEST_FAIL,
      message: `Control ${controlId} cancel failed`
    });
    throw err;
  }
};

export const setDeletedControls =
  deletedControls => async (dispatch, getState) => {
    try {
      await dispatch({
        type: SET_DELETED_CONTROLS_SUCCESS,
        data: deletedControls
      });
      return deletedControls;
    } catch (err) {
      // Redundant catch-throw, but maintaining this until we update polling
      throw err;
    }
  };

export const setControls = controls => async (dispatch, getState) => {
  try {
    await dispatch({
      type: SET_CONTROLS_SUCCESS,
      data: controls
    });
    return controls;
  } catch (err) {
    // Redundant catch-throw, but maintaining this until we update polling
    throw err;
  }
};
